// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'box-crosshair';

export const Component = () => (
  <path d='M11.781 4.885V0h.958v4.885h-.958ZM0 12.74v-.958h4.885v.958H0Zm12.74-.958V4.885h6.897v6.897H12.74Zm-.959 12.74v-4.886h.958v4.885h-.958Zm-6.896-12.74V4.885h6.897v6.897H4.885Zm7.855 7.854v-6.897h6.897v6.897H12.74Zm6.896-6.896v-.958h4.885v.958h-4.885Zm-14.75 6.896v-6.897h6.896v6.897H4.885Z' />
);

export const viewBox = '0 0 25 25';
